import { createApp } from 'vue';
import pinia from "@/stores";
import * as Vue3EasyDataTable from "vue3-easy-data-table";
import { Modal } from "bootstrap";
import App from './App.vue';
import router from './router';
import { i18n } from "@/i18n";

import "@/assets/main.css";
import '@/sass/main.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "vue3-easy-data-table/dist/style.css";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
const app = createApp(App)
app.use(pinia);
app.use(i18n);
app.use(router);
app.component("EasyDataTable", (Vue3EasyDataTable as any).default);
app.component('VueDatePicker', Datepicker);
app.directive("b-modal", {
    mounted(el) {
        const modal = new Modal(el);
    }
});
app.mount('#app')